module.exports = __webpack_public_path__ + "static/img/yx10.fdd5964.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yx10.jpg
// module id = GFnq
// module chunks = 1